import type {ReactElement} from 'react';
import {SidebarTrigger} from '@AiChat/components/ai-chat-sidebar/components/sidebar-trigger/sidebar-trigger';
import {AiChatCreditsDropdown} from '@AiChat/components/ai-chat-credits-dropdown/ai-chat-credits-dropdown';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {isUserPremium, isUserPremiumPlus} from '@Libraries/user.library';
import {noop} from '@Utils/general.util';

export function SidebarCreditsTrigger(): ReactElement | null {
  const {state} = useAiChat();

  if (!state.isEmbedded) {
    return null;
  }

  if (!state.isUserLoggedIn) {
    return null;
  }

  if (!isUserPremium() && !isUserPremiumPlus() && !state.isPaygUserWithAiChatAccess) {
    return null;
  }

  return (
    <AiChatCreditsDropdown
      alignment={ALIGNMENT_TYPE.RIGHT_END}
      selector={<SidebarTrigger tooltip={window.i18next.t('pmwjs_ai_credits_remaining')} icon="icon-flash" onClick={noop} />}
    />
  );
}
